import { customTv } from "#utils";

export type TagColor =
  | "indigo"
  | "bright-indigo"
  | "purple"
  | "bright-purple"
  | "pink"
  | "bright-pink"
  | "red"
  | "bright-red"
  | "orange"
  | "bright-orange"
  | "yellow"
  | "bright-yellow"
  | "green"
  | "bright-green"
  | "blue"
  | "bright-blue"
  | "grey"
  | "dark-grey"
  // Figma "Region" tag: a transparent, outlined, mono-text variant used for
  // region-style labels (e.g. "us-east-2").
  | "region";

export const tagStyles = customTv({
  base: "gap-x-xs inline-flex items-center justify-center text-label-extra-small leading-[normal] font-bold capitalize px-xs py-3xs rounded-md",
  variants: {
    // Background + text colors map 1:1 to the Figma "Design Kit v2" Tag palette.
    color: {
      indigo: "bg-data-viz-soft-indigo text-data-viz-indigo-900",
      "bright-indigo": "bg-data-viz-bright-indigo text-data-viz-indigo-50",
      purple: "bg-data-viz-soft-violet text-data-viz-violet-900",
      "bright-purple": "bg-data-viz-bright-violet text-data-viz-violet-50",
      pink: "bg-data-viz-soft-pink text-data-viz-pink-900",
      "bright-pink": "bg-data-viz-bright-pink text-data-viz-pink-50",
      red: "bg-data-viz-soft-red text-data-viz-red-900",
      "bright-red": "bg-data-viz-bright-red text-data-viz-red-50",
      orange: "bg-data-viz-soft-orange text-stacklet-orange-900",
      "bright-orange": "bg-data-viz-bright-orange text-stacklet-orange-50",
      yellow: "bg-data-viz-soft-yellow text-data-viz-yellow-900",
      "bright-yellow": "bg-data-viz-bright-yellow text-data-viz-yellow-900",
      green: "bg-data-viz-soft-green text-data-viz-green-900",
      "bright-green": "bg-data-viz-bright-green text-data-viz-green-50",
      blue: "bg-data-viz-soft-blue text-data-viz-blue-900",
      "bright-blue": "bg-data-viz-bright-blue text-data-viz-blue-50",
      grey: "bg-data-viz-soft-grey text-text-tag",
      "dark-grey": "bg-neutral-700 text-neutral-50",

      // The Figma "Region" tag: a transparent fill with a foreground-primary
      // border and foreground-primary text. Tighter line-height keeps the same
      // 17px height as other tags despite the 1px border. Uses mono,
      // regular-weight, non-capitalized text, which overrides the base font styles.
      region:
        "border border-foreground-primary bg-transparent text-foreground-primary leading-[11px] font-mono font-normal normal-case",
    },
  },
  defaultVariants: {
    color: "indigo",
  },
});
